// Carousel3D.jsx
import React, { useState, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import './Carousel3D.css';
import { useNavigate } from 'react-router-dom';

const cards = [
  {
    id: 1,
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190130/ebm/reglasParticipacionFamiliar_bnqw1y.svg',
    text: 'Si deseas <b>establecer reglas claras para la participación familiar</b> en la empresa preservando la armonía.'
  },
  {
    id: 2,
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190131/ebm/crecimientoSostenible_jffuxg.svg',
    text: 'Si necesitas apoyo para <b>impulsar el crecimiento sostenible de tu empresa</b> desarrollando su planeación estratégica y financiera.'
  },
  {
    id: 3,
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190131/ebm/transicionLiderazgo_jftv2t.svg',
    text: 'Si te preocupa la continuidad de la empresa y <b>quieres planear una transición de liderazgo</b> ordenada y exitosa.'
  },
  {
    id: 4,
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190130/ebm/gobiernoCorporativo_ac48wx.svg',
    text: 'Si buscas <b>establecer o mejorar el gobierno corporativo en tu empresa</b> para alinear esfuerzos y asegurar una gestión transparente.',
    ruta: '/ejes-de-accion/empresa'
  },
  {
    id: 5,
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190130/ebm/futurasGeneraciones_n8xvjv.svg',
    text: 'Si buscas <b>preparar a las futuras generaciones para asumir roles de liderazgo</b> y alcanzar la sucesión patrimonial de manera responsable.',
    ruta: '/ejes-de-accion/familia'
  },
  {
    id: 6,
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190129/ebm/estructurarPatrimonio_y7lzgl.svg',
    text: 'Si deseas <b>estructurar legal y financieramente tu patrimonio</b>, cuidando la eficiencia fiscal.',
    ruta: '/ejes-de-accion/propiedad'
  },
  {
    id: 7,
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1783442144/ebm/icon-cfo_as55t1.png',
    text: 'Si buscas <b>dejar de operar a ciegas, incorporando la visión de un CFO</b> para anticipar tus necesidades de capital y respaldar tus decisiones diarias.'
  },
  {
    id: 8,
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1783008906/ebm/icon-inversion_wfyum5.svg',
    text: 'Si necesitas <b>estructurar tu próximo proyecto de inversión</b> con el rigor técnico y la certidumbre matemática que exigen los fondos de capital.'
  },
  {
    id: 9,
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1783008906/ebm/icon-flujo_zfbpsw.svg',
    text: 'Si <b>te preocupa que tu cuenta bancaria no crezca</b> a pesar de facturar más, y deseas transformar tu contabilidad en verdadera inteligencia de negocios para controlar tu flujo.'
  },
];

export default function Carousel3D() {
  const [current, setCurrent] = useState(0);
  const cardCount = cards.length;
  const startX = useRef(0);
  const navigate = useNavigate();

  const handlePrev = () => setCurrent((prev) => (prev - 1 + cardCount) % cardCount);
  const handleNext = () => setCurrent((prev) => (prev + 1) % cardCount);

  const handleTouchStart = (e) => (startX.current = e.touches[0].clientX);
  const handleTouchMove = (e) => {
    const deltaX = e.touches[0].clientX - startX.current;
    if (Math.abs(deltaX) > 50) {
      deltaX > 0 ? handlePrev() : handleNext();
      startX.current = e.touches[0].clientX;
    }
  };

  const handleCardClick = (card) => {
    if (card.ruta) {
      navigate(card.ruta);
    }
  };

  const arrowStyle = {
    position: 'absolute',
    top: '50%',
    width: '45px',
    height: '45px',
    p: '10px',
    borderRadius: '50px',
    background: 'linear-gradient(25deg, #0A6274 10%, #13B8DA)',
    color: 'white',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '-2px -2px 5px rgba(255,255,255,0.2), 2px 2px 5px rgba(0,0,0,0.2)',
    transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
    fontWeight: 500,
    zIndex: 100,
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: '50px',
      background: 'linear-gradient(180deg, #0ff, #0A6274)',
      WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
      WebkitMaskComposite: 'xor',
      maskComposite: 'exclude',
      zIndex: -1,
      transition: 'opacity 0.3s ease',
    },
  };

  return (
    <Box className="carousel-container">
      <Box
        component="img"
        src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1744736422/arrow-left_b2m1ub.png"
        alt="left"
        sx={{ ...arrowStyle, left: '20px', cursor: 'pointer', transform: {xs:'translateY(180px)', md:'translateY(-50%)'}, }}
        onClick={handlePrev}
      />

      <Box
        className="carousel"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
      >
        {cards.map((card, index) => {
          const offset = (index - current + cardCount) % cardCount;

          let classNames = 'card';

          if (offset === 0) {
            classNames += ' level-1';
          } else if (offset === 1 || offset === cardCount - 1) {
            classNames += ' level-2 ' + (offset === 1 ? 'right' : 'left');
          } else if (offset === 2 || offset === cardCount - 2) {
            classNames += ' level-3 ' + (offset === 2 ? 'right' : 'left');
          } else if (offset === 3 || offset === cardCount - 3) {
            classNames += ' level-4';
          }

          return (
            <Box
              key={card.id}
              className={classNames}
              onClick={() => handleCardClick(card)}
              sx={{
                cursor: card.ruta ? 'pointer' : 'default'
              }}
            >
              <img
                src={card.icon}
                alt={`icon-${card.id}`}
                style={{ height: '125px', maxHeight: '125px', marginBottom: '10px' }}
              />
              <Box
                sx={{
                  width: '80px',
                  height: '3px',
                  backgroundColor: '#0A6274',
                  marginBottom: '10px',
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontSize: '14px',
                  textAlign: 'justify',
                  color: 'black',
                }}
                dangerouslySetInnerHTML={{ __html: card.text }}
              />
            </Box>
          );
        })}
      </Box>

      <Box
        component="img"
        src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1744736422/arrow-right_fdt25g.png"
        alt="right"
        sx={{ ...arrowStyle, right: '20px', cursor: 'pointer', transform: {xs:'translateY(180px)', md:'translateY(-50%)'} }}
        onClick={handleNext}
      />
    </Box>
  );
}